/**
 * A tax rate's (or rate template's) validity window as one short label:
 * "From 2026-10-01", "Until 2026-12-31", "a – b", or "" for an open window.
 * Shared by the tax-rate templates grid and the line picker's "Rates for other
 * dates" section (InvoiceLineItems). Days are plain `YYYY-MM-DD` calendar days
 * (docs/DATES.md), printed as stored.
 */
export type WindowLabelTranslate = (key: string, options?: Record<string, unknown>) => string;

const NS = 'taxRateTemplates.templates.window';

export function windowLabel(t: WindowLabelTranslate, from: string | null, to: string | null): string {
  if (from && to) return t(`${NS}.range`, { from, to });
  if (to) return t(`${NS}.until`, { date: to });
  if (from) return t(`${NS}.from`, { date: from });
  return '';
}
